<script>
  import MoleculeAvatarUserCard from "@/components/molecules/MoleculeAvatarUserCard.vue";
  import AtomCheckbox from "@/components/atoms/AtomCheckbox.vue";
  import AtomParagraph from "@/components/atoms/AtomParagraph.vue";

  export default {
    components: {
      MoleculeAvatarUserCard,
      AtomCheckbox,
      AtomParagraph,
    },
    props: {
      users: {
        type: Array,
        default: () => [],
      },
      selectedUsers: {
        type: Array,
        default: () => [],
      },
      showMoreButton: {
        type: Boolean,
        default: false,
      },
      loadingMore: {
        type: Boolean,
        default: false,
      },
    },
    methods: {
      isUserSelected(user) {
        return this.selectedUsers.some((u) => u._id === user._id);
      },
      platforms(user) {
        const order = ["LiveJasmin", "Streamate"];
        const creds = user?.credentials || [];
        const result = [];

        order.forEach((platformName) => {
          creds.forEach((item) => {
            if (item?.password && item?.platformId && item.platformId.name === platformName) {
              result.push({ id: item._id, name: item.platformId.name, logo: item.platformId.logo });
            }
          });
        });

        return result;
      },
    },
  };
</script>

<template>
  <div class="userList__usersContainer custom__scroll">
    <label v-for="user in users" :key="user._id" class="userList__usersSubContainer" :class="{ isCheckedUserClass: isUserSelected(user) }">
      <AtomCheckbox class="userList__userCheck" @onChange="(event) => $emit('isCheckedAction', { user, event })" :value="isUserSelected(user)" />
      <MoleculeAvatarUserCard :icon="user" :defaultText="user.artisticName" />
      <div class="userList__platforms" v-if="user.role === 'model' && platforms(user).length">
        <div class="userList__contentLogos" v-for="platform in platforms(user)" :key="platform.id">
          <img class="userList__logo" :src="platform.logo" :alt="platform.name" />
        </div>
      </div>
    </label>
    <button v-if="showMoreButton" class="userList__moreButton" :disabled="loadingMore" @click="$emit('handleClickMorebutton')">Cargar más</button>
  </div>
</template>

<style lang="scss">
  .userList {
    &__usersContainer {
      max-height: 305px;
      overflow-y: auto;
    }
    &__listAreasName {
      @include Flex(row, flex-start);
      min-width: 100%;
      height: auto;
      margin: 0.5rem 0;
      padding-top: 4px;
      gap: 0.5rem;
      cursor: pointer;
      :hover {
        background: #f6f6f6;
        border-radius: 0.5rem;
      }
    }
    &__listAreasNameContainer {
      @include Flex(row, space-between);
      width: 100%;
      height: 40px;
      padding: 0 8px;
      cursor: pointer;
      :hover {
        background: #f6f6f6;
        border-radius: 6px;
      }
    }

    &__moreButton {
      background: none;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      padding: 6px 16px;
      font-size: 13px;
      color: #555;
      cursor: pointer;
      transition: background 0.2s;
      margin-top: 15px;
      &:hover:not(:disabled) {
        background: #f5f5f5;
      }
      &:disabled {
        opacity: 0.6;
        cursor: default;
      }
    }

    &__checkArea,
    &__userCheck {
      width: 1.1rem;
      height: 1.1rem;
      appearance: none;
      background: #fff;
      position: relative;
      font-size: 120%;
      border: solid 1px rgba(221, 221, 221, 1);
      border-radius: 4px;
      box-sizing: border-box;
      cursor: pointer;
      &:checked {
        background-color: $lipstick;
        border-color: $lipstick;
        color: $white;
      }
      &:checked:before {
        content: "\2713";
        position: absolute;
        font-size: 80%;
        font-weight: bold;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
      }
      &:hover {
        border-radius: 4px;
      }
    }

    &__userCheck {
      width: 1rem;
      height: 1rem;
    }
    &__areaCheckName {
      text-transform: capitalize;
    }
    &__userCheckName {
      text-transform: capitalize;
    }

    &__usersSubContainer {
      margin: 0.2rem 0;
      @include Flex(row, flex-start);
      padding: 0.5rem 0 0.5rem 1.2rem;
      width: 98%;
      gap: 10px;
      border-radius: 10px;
      cursor: pointer;
      &:hover {
        background: #f0f0f0;
      }
      &.isCheckedUserClass {
        background: rgba(189, 9, 9, 0.05);
      }
    }
    &__platforms {
      @include Flex(row, flex-end);
      gap: 8px;
      margin-left: auto;
      margin-right: 8px;
    }
    &__contentLogos {
      position: relative;
    }
    &__logo {
      width: 15px;
      height: 15px;
      object-fit: contain;
      display: block;
      border-radius: 5px;
      opacity: 0.9;
    }
    &__userImg {
      width: 25px;
      height: 25px;
      border: 1.5px solid $primary;
    }
  }
</style>
